import { Row, Spacer, Title } from '@smuchile/pkg-unimarc-components'
import { getGlobalStyle } from '@smuchile/pkg-unimarc-components/helpers'

export const PagesContainerDescriptionTitle = ({
  title,
  isMobile
}: {
  title?: string
  isMobile?: boolean
}) => {
  if (!title) return null

  return (
    <>
      <Row maxWidth={getGlobalStyle('--width-max-desktop')}>
        <Title
          customFontSize={
            isMobile
              ? getGlobalStyle('--font-size-titles-xs')
              : getGlobalStyle('--font-size-titles-lg')
          }
          fontWeight='regular'
          headingLevel='h2'
        >
          {title}
        </Title>
      </Row>
      <Spacer.Horizontal size={18} />
      <Spacer.Horizontal size={2} />
    </>
  )
}
